/* Android browser promotion. No analytics, redirects or changes to shopping controls. */
(function () {
  'use strict';
  const element = document.getElementById('ms-android-app-prompt');
  if (!element || element.dataset.ready) return;
  const card = element;
  const closeButton = card.querySelector('[data-app-prompt-close]');
  const appLink = card.querySelector('[data-app-prompt-link]');
  if (!closeButton || !appLink) return;
  card.dataset.ready = 'true';
  var key = 'ms_android_app_prompt_until';
  var ninetyDays = 90 * 24 * 60 * 60 * 1000;
  var dismissed = false;
  var installed = false;
  var ready = false;
  var ua = navigator.userAgent || '';

  function inApp() {
    return /MaltashopperApp/i.test(ua) || Boolean(window.MSAppNative) ||
      Boolean(window.MSApp && window.MSApp.inApp) || Boolean(window.ReactNativeWebView) ||
      document.documentElement.classList.contains('ms-app');
  }

  function blockedPage() {
    return /(?:^|\/)(?:cart(?:[/.]|$)|checkouts?(?:\/|$)|account(?:\/|$)|pages\/app(?:\/|$))/i.test(location.pathname);
  }

  function remembered() {
    var until = 0;
    try { until = Number(localStorage.getItem(key)) || 0; } catch (_) { /* Cookies are the fallback. */ }
    var cookie = document.cookie.split('; ').find(function (entry) { return entry.indexOf(key + '=') === 0; });
    if (cookie) until = Math.max(until, Number(cookie.slice(key.length + 1)) || 0);
    return until > Date.now();
  }

  if (!/Android/i.test(ua) || !/Mobile/i.test(ua) || /iPhone|iPad|iPod|Windows Phone/i.test(ua) ||
      (navigator.userAgentData && !navigator.userAgentData.mobile) ||
      inApp() || blockedPage() || remembered() || (window.Shopify && window.Shopify.designMode)) return;

  /** @param {Element} element */
  function visible(element) {
    if (element.closest('[hidden], [aria-hidden="true"]') || !element.getClientRects().length ||
        getComputedStyle(element).visibility === 'hidden') return false;
    var rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function busy() {
    if (document.body.classList.contains('overflow-hidden')) return true;
    return Array.from(document.querySelectorAll(
      'cart-drawer.active, cart-notification.active, dialog[open], [aria-modal="true"], .cc-window, #isense-cc-window, #consentmo-cookie-banner'
    )).some(visible);
  }

  function sync() {
    var keyboardOpen = Boolean(window.visualViewport && window.visualViewport.height < window.innerHeight * 0.75);
    card.hidden = !ready || dismissed || installed || document.visibilityState === 'hidden' ||
      inApp() || blockedPage() || remembered() || busy() || keyboardOpen;
  }

  function dismiss() {
    dismissed = true;
    var until = String(Date.now() + ninetyDays);
    try { localStorage.setItem(key, until); } catch (_) { /* Keep the cookie fallback. */ }
    try { document.cookie = key + '=' + until + '; Max-Age=' + ninetyDays / 1000 + '; Path=/; SameSite=Lax; Secure'; } catch (_) { /* Still hide in this page. */ }
    card.hidden = true;
  }

  closeButton.addEventListener('click', dismiss);
  appLink.addEventListener('click', dismiss);
  card.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') dismiss();
  });
  window.addEventListener('storage', function (event) { if (event.key === key) sync(); });
  window.addEventListener('pageshow', sync);
  window.addEventListener('popstate', sync);
  document.addEventListener('visibilitychange', sync);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', sync);

  // Observe overlays without polling or reacting to this card's own hidden attribute.
  var queued = false;
  new MutationObserver(function (records) {
    if (queued || !records.some(function (record) { return !card.contains(record.target); })) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }).observe(document.body, { subtree: true, childList: true, attributes: true,
    attributeFilter: ['class', 'style', 'open', 'aria-hidden', 'aria-modal', 'hidden'] });

  // Unsupported browsers and older app builds use the 90-day rule instead.
  var checked = Promise.resolve();
  if (typeof navigator.getInstalledRelatedApps === 'function') {
    checked = Promise.resolve().then(function () { return navigator.getInstalledRelatedApps?.(); })
      .then(function (apps) {
        installed = (apps || []).some(function (app) { return app.platform === 'play' && app.id === 'com.maltashopper.app'; });
        sync();
      }).catch(function () { /* Detection is optional. */ });
  }
  Promise.all([checked, new Promise(function (resolve) { setTimeout(resolve, 8000); })])
    .then(function () { ready = true; sync(); });
})();
